export enum SyncError {
  defectFilesBatchUpload = 'defectFilesBatchUpload',
  inspectionFilesBatchUpload = 'inspectionFilesBatchUpload',
  saveInspection = 'saveInspection',
  unexpectedError = 'unexpectedError',
  uploadDefectFiles = 'uploadDefectFiles',
  uploadInspectionFiles = 'uploadInspectionFiles',
}
